module.exports = __webpack_public_path__ + "img/lair-throne-primed.ada82da5.jpeg";